import { useI18n } from "@core/i18n/i18n";
import { DIALOG_SIZE } from "@ui/components/dialog/base-dialog";
import { ConfirmActionDialog } from "@ui/pages/program-builder/dialog/confirm-dialog";
import { DialogProps } from "primereact/dialog";
import React, { useCallback } from "react";

export interface SaveChangesDialogProps extends DialogProps {
	onConfirm?: () => void;
	onCancel?: () => void;
	message: string;
}

export const SaveChangesDialog = ({
	onConfirm,
	onCancel,
	message,
	...otherProps
}: SaveChangesDialogProps): JSX.Element => {
	const { format } = useI18n();

	const handleConfirm = useCallback(() => {
		onConfirm?.();
		otherProps.onHide();
	}, [onConfirm, otherProps]);

	const handleCancel = useCallback(() => {
		onCancel?.();
		otherProps.onHide();
	}, [onCancel, otherProps]);

	return (
		<ConfirmActionDialog
			{...otherProps}
			onConfirm={handleConfirm}
			onCancel={handleCancel}
			onHide={handleCancel}
			title={format("global.saveChangesDialog.title")}
			confirmButtonLabel={format("global.saveChangesDialog.confirmButtonLabel")}
			message={message}
			width={DIALOG_SIZE.M}
		/>
	);
};
